"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _react = _interopRequireDefault(require("react"));
var _App2 = _interopRequireDefault(require("default-app/dist/common/components/App"));
var _setContents = _interopRequireDefault(require("default-app/dist/common/setContents"));
var _Canvas = _interopRequireDefault(require("./components/Canvas"));
function _default() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  (0, _setContents["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, p), {}, {
    App: function App(props) {
      return /*#__PURE__*/_react["default"].createElement(_App2["default"], Object.assign({
        Canvas: _Canvas["default"]
      }, props));
    }
  }));
}